module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/bg_top-235221c7c9dd31671dcfe3f7c1992962.png";